import { CardProps, Card as MuiCard } from '@mui/material';
import React from 'react';

export const Card = ({ children, ...props }: CardProps) => {
    return (
        <MuiCard variant="outlined" {...props}>
            {children}
        </MuiCard>
    );
};
